<template>
  <div class="works" id="works">
    <div id="topAnchor" ref="faultTree" class="activity_details_swiper">
      <van-swipe :autoplay="5000" indicator-color="#3562FF">
        <van-swipe-item v-for="(item, index) in activityData.activeImageList" :key="index">
          <img :src="item" alt="" title="" style="object-fit: scale-down" />
        </van-swipe-item>
      </van-swipe>
      <div class="activity_details_swiper_span">
        <span class="page_data_item_img1" v-if="activityData.activeState == 1">{{
          $t('message.home.t_start')
        }}</span>
        <span class="page_data_item_img2" v-else-if="activityData.activeState == 2">{{
          $t('message.home.i_pro')
        }}</span>
        <span class="page_data_item_img3" v-else-if="activityData.activeState == 3">{{
          $t('message.home.ended')
        }}</span>
      </div>
    </div>
    <div class="css_margin">
      <div class="nav_list_head" v-if="navTabList.length != 1">
        <div
          class="nav_list_head_li"
          @click="navHeaClick(item.id)"
          v-for="(item, index) in navTabList"
          :key="index"
          :class="item.id * 1 == navTabIndex ? 'active' : ''"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="nav_list_works">
        <!-- <div
          class="nav_list_works_li"
          @click="navListClick(item.id)"
          v-for="(item, index) in navWorksList"
          :key="index"
          :class="navWorksIndex === item.id ? 'active' : ''"
        >
          {{ item.name }}
        </div> -->

        <!-- 最新作品 -->
        <div
          class="nav_list_works_li"
          @click="navListClick(1)"
          :class="navWorksIndex == 1 ? 'active' : ''"
        >
          {{ this.$t('message.home.latest') }}
        </div>

        <!-- 热门作品 -->
        <div
          class="nav_list_works_li"
          @click="navListClick(2)"
          :class="navWorksIndex == 2 ? 'active' : ''"
        >
          {{ this.$t('message.home.pop_works') }}
        </div>

        <!-- 获奖作品    @click="awardWorksClick(3)" -->
        <div
          class="nav_list_works_li"
          @click="awardWorksClick(3)"
          :class="navWorksIndex == 3 ? 'active' : ''"
          v-if="activityData.isWorkShow || activityData.isPopularityAward"
        >
          {{ this.$t('message.home.Award_works') }}
        </div>

        <!-- 机构榜单 -->
        <div
          class="nav_list_works_li"
          @click="clickOrganization(4)"
          :class="navWorksIndex == 4 ? 'active' : ''"
          v-if="activityData.monthlyFocus || activityData.divisionMonthlyFocus"
        >
          {{ this.$t('message.home.List_of_Organizations') }}
        </div>

        <!-- 搜索 -->
        <div class="new_seach" @click="searchClick" v-show="organization">
          <van-icon name="search" />
        </div>
      </div>
      <!-- 获奖作品不显示赛区 -->
      <div class="saiqu" v-show="navWorksIndex != 3 && navWorksIndex != 4">
        <div
          class="saiqu_li"
          @click="saiQuClick(index)"
          v-for="(item, index) in SaiquList"
          :class="navSaiIndex == index ? 'active' : ''"
          :key="index"
        >
          {{ item }}
        </div>
      </div>
      <!-- 获奖作品显示周评 listByAward -->
      <div class="saiqu" v-show="navWorksIndex == 3">
        <div
          v-show="activityData.isPopularityAward"
          class="saiqu_li"
          @click="clickPopularityAward({}, -1)"
          :class="getByAwardIndex == -1 ? 'active' : ''"
        >
          {{ this.$t('message.popularityAward') }}
        </div>
        <span
          v-show="activityData.isPopularityAward && activityData.isWorkShow"
          style="
            background-color: #8f8fab;
            display: inline-block;
            width: 1px;
            height: 16px;
            transform: translateY(50%);

            margin: 0 10px 5px 4px;
          "
        ></span>
        <template v-if="activityData.isWorkShow">
          <div
            class="saiqu_li"
            @click="clickByAward(item, index)"
            v-for="(item, index) in byAwardList"
            :class="getByAwardIndex == index ? 'active' : ''"
            :key="index"
          >
            {{ item.addWork }}
          </div>
        </template>
      </div>
      <!-- 新获奖 -->
      <div v-if="newWorksAward" class="newAward">
        <!-- 标题 -->
        <van-list
          offset="100"
          v-model="loadingAward"
          :finished="finishedAward"
          @load="getByAwardIndex == -1 ? getPopularityAward() : getAward()"
        >
          <div class="new_award_item" v-for="(item, index) in awardList" :key="index">
            <template v-if="getByAwardIndex != -1">
              <div class="new_award_item_title" v-show="!queryAward.awardZhcn">
                <div class="new_award_item_title_img">
                  <img src="../../../../static/image/index(3).png" alt="" />
                </div>
                {{ item }}
              </div>
            </template>

            <div class="new_award_item_context">
              <div
                v-for="(it, ind) in awardData"
                :key="ind"
                class="new_award_item_context_item"
                v-show="it.addWork == item"
              >
                <div v-if="it.addWork == item">
                  <div @click="awardDetailsClick(it)">
                    <div class="abpos" v-if="it.worksList && it.worksList.length > 0">
                      <i class="icon-jr-icon-one iconfont"></i>
                      <span>{{ it.quantity }}</span>
                    </div>
                    <img
                      v-if="it.worksList != [] && it.worksList && it.worksList.length > 0"
                      :src="it.worksList[0].workPath"
                      alt=""
                    />
                    <img
                      v-else-if="it.workVideoList && it.workVideoList != []"
                      :src="it.workVideoList[0]"
                    />
                    <img v-else-if="it.workTiffList" :src="it.workTiffList[0]" />
                    <img v-else src="../../../../static/image/moren.png" alt="" />
                  </div>

                  <div class="data_list_li_p">
                    <p>
                      <i class="icon-jr-icon-data iconfont"></i>{{ it.votes ? it.votes + 1 : 1
                      }}{{ $t('message.home.votes') }}
                    </p>
                    <span v-if="!it.isVote" @click.stop="awardVoteClick(it, ind)">{{
                      $t('message.home.Vote')
                    }}</span>
                    <span v-else>{{ $t('message.home.Voted') }}</span>
                  </div>
                </div>
              </div>
              <!--
            <div
              v-for="(it, ind) in awardData"
              :key="ind"
              class="new_award_item_context_item"
              v-show="it.addWork == item"
            >
              <div @click="detailsClick(item)">
                <div class="abpos" v-if="item.worksList && item.worksList.length > 0">
                  <i class="icon-jr-icon-one iconfont"></i>
                  <span>{{ item.quantity }}</span>
                </div>
                <img v-if="item.worksList" :src="item.worksList[0].workPath" alt="" />
                <img
                  v-else-if="!item.worksList && item.workVideoList"
                  :src="item.workVideoList[0]"
                />
                <img v-else-if="item.workTiffList" :src="item.workTiffList[0]" />
                <img v-else src="../../../../static/image/moren.png" alt="" />
              </div>
              <div class="data_list_li_p">
                <p>
                  <i class="icon-jr-icon-data iconfont"></i>{{ item.votes ? item.votes + 1 : 1
                  }}{{ $t('message.home.votes') }}
                </p>
                <span v-if="!item.isVote" @click.stop="voteClick(item, index)">{{
                  $t('message.home.Vote')
                }}</span>
                <span v-else @click="voteClickNo">{{ $t('message.home.Voted') }}</span>
              </div>
            </div> -->
            </div>
          </div>
        </van-list>
      </div>

      <!-- 赛区榜单tab栏 -->
      <div class="list_tab" v-show="!organization && newWorksAward == false">
        <div
          class="list_tab_item"
          :class="{
            list_active: listActive == 0
          }"
          @click="clickListTabItem(0)"
          v-show="activityData.divisionMonthlyFocus"
        >
          赛区榜
        </div>
        <div
          class="list_tab_item"
          :class="{
            list_active: listActive == 1
          }"
          v-show="activityData.monthlyFocus"
          @click="clickListTabItem(1)"
        >
          机构榜
        </div>
      </div>
      <!-- 赛区榜 -->
      <div
        v-show="
          !organization &&
          listActive == 0 &&
          activityData.divisionMonthlyFocus &&
          newWorksAward == false
        "
        class="division_table"
      >
        <!-- <div class="organization_title">
          <div class="circle"></div>
          <div class="organization_title_center">赛区榜</div>
        </div> -->
        <div class="organization_box">
          <div class="head_img_box">
            <!-- <img src="../../../../static/image/2840.png" alt="" /> -->
            <img src="../../../../static/image/赛区.png" alt="" />
          </div>

          <div class="organization_content">
            <div class="organization_content_head">
              <div class="organization_name">赛区名称</div>
              <div class="number_works">作品</div>
              <div v-if="navTabIndex != 2" class="number_img">图片</div>
              <div v-else class="number_img">视频</div>
            </div>
            <div
              class="organization_content_item"
              v-for="(item, index) in divisionList"
              :key="index"
              @click="clickToContribute(item, index)"
            >
              <div class="organization_name">
                <div class="list_icon">
                  <img src="../../../../static/image/index(2).png" alt="" v-if="index == '0'" />
                  <img
                    src="../../../../static/image/index(1).png"
                    alt=""
                    v-else-if="index == '1'"
                  />
                  <img src="../../../../static/image/index.png" alt="" v-else-if="index == '2'" />
                  <div class="icon_txt">{{ index + 1 }}</div>
                </div>

                <div class="organization_logo">
                  <img :src="item.logo" alt="" />
                </div>

                <div
                  style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 70%"
                >
                  {{ item.divisionName }}
                </div>
              </div>
              <!--  -->
              <div class="number_works">
                <div v-if="navTabIndex == 3">
                  {{ item.cumulativePicture }}
                </div>

                <div v-if="navTabIndex == 2">
                  {{ item.cumulativeVideo }}
                </div>

                <div v-if="navTabIndex == 4">{{ item.cumulativePaintings }}</div>

                <div v-if="navTabIndex == 6">{{ item.cumulativeKechuang }}</div>
              </div>
              <div class="number_img">
                <div v-if="navTabIndex == 3">
                  {{ item.cumulativePictureSum }}
                </div>

                <div v-if="navTabIndex == 2">
                  {{ item.cumulativeVideoSum }}
                </div>

                <div v-if="navTabIndex == 4">{{ item.cumulativePaintingsSum }}</div>

                <div v-if="navTabIndex == 6">{{ item.cumulativeKechuangSum }}</div>

                <div
                  style="
                    color: red;
                    background-color: #f9cdcd;
                    padding: 2px;
                    font-size: 10px;
                    border-radius: 4px;
                  "
                  v-if="index <= 2"
                >
                  热
                </div>

                <div class="organization_content_item_state" v-if="navTabIndex == 3">
                  <div class="rise" v-if="item.lift > 0">
                    <div class="rise_icon"></div>
                    {{ item.lift }}
                  </div>

                  <div class="decline" v-else-if="item.lift < 0">
                    <div class="decline_icon"></div>
                    {{ item.lift | lift }}
                  </div>
                </div>

                <div class="organization_content_item_state" v-else-if="navTabIndex == 2">
                  <div class="rise" v-if="item.videoLift > 0">
                    <div class="rise_icon"></div>
                    {{ item.videoLift }}
                  </div>

                  <div class="decline" v-else-if="item.videoLift < 0">
                    <div class="decline_icon"></div>
                    {{ item.videoLift | lift }}
                  </div>
                </div>

                <div class="organization_content_item_state" v-else-if="navTabIndex == 4">
                  <div class="rise" v-if="item.paintingsLift > 0">
                    <div class="rise_icon"></div>
                    {{ item.paintingsLift }}
                  </div>

                  <div class="decline" v-else-if="item.paintingsLift < 0">
                    <div class="decline_icon"></div>
                    {{ item.paintingsLift | lift }}
                  </div>
                </div>

                <div class="organization_content_item_state" v-else-if="navTabIndex == 6">
                  <div class="rise" v-if="item.kechuangLift > 0">
                    <div class="rise_icon"></div>
                    {{ item.kechuangLift }}
                  </div>

                  <div class="decline" v-else-if="item.kechuangLift < 0">
                    <div class="decline_icon"></div>
                    {{ item.kechuangLift | lift }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 机构榜单 -->
      <div
        v-show="
          !organization && listActive == 1 && activityData.monthlyFocus && newWorksAward == false
        "
        class="organization"
      >
        <!-- <div class="organization_title">
          <div class="circle"></div>
          <div class="organization_title_center">机构榜</div>
        </div> -->
        <div class="organization_box">
          <div class="head_img_box">
            <img src="../../../../static/image/机构.png" alt="" />
          </div>

          <div class="organization_content">
            <div class="organization_content_head">
              <div class="organization_name">机构名称</div>
              <div class="number_works">作品</div>
              <div v-if="navTabIndex != 2" class="number_img">图片</div>
              <div v-else class="number_img">视频</div>
            </div>
            <div
              class="organization_content_item"
              v-for="(item, index) in organizationList"
              :key="index"
              @click="clickToContributeTwo(item, index)"
            >
              <div class="organization_name">
                <div class="list_icon">
                  <img src="../../../../static/image/index(2).png" alt="" v-if="index == '0'" />
                  <img
                    src="../../../../static/image/index(1).png"
                    alt=""
                    v-else-if="index == '1'"
                  />
                  <img src="../../../../static/image/index.png" alt="" v-else-if="index == '2'" />
                  <div class="icon_txt">{{ index + 1 }}</div>
                </div>

                <div class="organization_logo">
                  <img :src="item.logo" alt="" />
                </div>

                <div
                  style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; width: 70%"
                >
                  {{ item.organizationName }}
                </div>
              </div>
              <!--  -->
              <div class="number_works">
                <div v-if="navTabIndex == 3">
                  {{ item.photographySum }}
                </div>

                <div v-if="navTabIndex == 2">
                  {{ item.videoSum }}
                </div>

                <div v-if="navTabIndex == 4">{{ item.paintingsPicturesSum }}</div>

                <div v-if="navTabIndex == 6">{{ item.kechuangPicturesSum }}</div>
              </div>
              <div class="number_img">
                <div v-if="navTabIndex == 3">
                  {{ item.photographyPicturesSum }}
                </div>

                <div v-if="navTabIndex == 2">
                  {{ item.videoPicturesSum }}
                </div>

                <div v-if="navTabIndex == 4">{{ item.paintingsSum }}</div>

                <div v-if="navTabIndex == 6">{{ item.kechuangSum }}</div>

                <div
                  style="
                    color: red;
                    background-color: #f9cdcd;
                    padding: 2px;
                    font-size: 10px;
                    border-radius: 4px;
                  "
                  v-if="index <= 2"
                >
                  热
                </div>

                <div class="organization_content_item_state" v-if="navTabIndex == 3">
                  <div class="rise" v-if="item.lift > 0">
                    <div class="rise_icon"></div>
                    {{ item.lift }}
                  </div>

                  <div class="decline" v-else-if="item.lift < 0">
                    <div class="decline_icon"></div>
                    {{ item.lift | lift }}
                  </div>
                </div>

                <div class="organization_content_item_state" v-else-if="navTabIndex == 2">
                  <div class="rise" v-if="item.videoLift > 0">
                    <div class="rise_icon"></div>
                    {{ item.videoLift }}
                  </div>

                  <div class="decline" v-else-if="item.videoLift < 0">
                    <div class="decline_icon"></div>
                    {{ item.videoLift | lift }}
                  </div>
                </div>

                <div class="organization_content_item_state" v-else-if="navTabIndex == 4">
                  <div class="rise" v-if="item.paintingsLift > 0">
                    <div class="rise_icon"></div>
                    {{ item.paintingsLift }}
                  </div>

                  <div class="decline" v-else-if="item.paintingsLift < 0">
                    <div class="decline_icon"></div>
                    {{ item.paintingsLift | lift }}
                  </div>
                </div>

                <div class="organization_content_item_state" v-else-if="navTabIndex == 6">
                  <div class="rise" v-if="item.kechuangLift > 0">
                    <div class="rise_icon"></div>
                    {{ item.kechuangLift }}
                  </div>

                  <div class="decline" v-else-if="item.kechuangLift < 0">
                    <div class="decline_icon"></div>
                    {{ item.kechuangLift | lift }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="data_list" v-show="organization">
        <van-list offset="100" v-model="loading" :finished="finished" @load="search()">
          <div class="data_list_li" v-for="(item, index) in dataList" :key="index">
            <div @click="detailsClick(item)">
              <div class="abpos" v-if="item.worksList && item.worksList.length > 0">
                <i class="icon-jr-icon-one iconfont"></i>
                <span>{{ item.quantity }}</span>
              </div>
              <img
                v-if="item.worksList != [] && item.worksList && item.worksList.length > 0"
                :src="item.worksList[0].workPath"
                alt=""
              />
              <img
                v-else-if="item.workVideoList && item.workVideoList != []"
                :src="item.workVideoList[0]"
              />
              <img v-else-if="item.workTiffList" :src="item.workTiffList[0]" />
              <img v-else src="../../../../static/image/moren.png" alt="" />
            </div>
            <div class="data_list_li_p">
              <p>
                <i class="icon-jr-icon-data iconfont"></i>{{ item.votes ? item.votes + 1 : 1
                }}{{ $t('message.home.votes') }}
              </p>
              <template v-if="item.exportAdvertising">
                <span @click.stop="voteClick(item, index)">
                  {{ $t('message.home.Vote') }}
                </span>
              </template>
              <template v-else>
                <span v-if="!item.isVote" @click.stop="voteClick(item, index)">
                  {{ $t('message.home.Vote') }}
                </span>
                <!-- 已投票 -->
                <span v-else @click="voteClickNo">{{ $t('message.home.Voted') }}</span>
              </template>
            </div>
          </div>
          <div class="data_list_img_show" v-if="showListImg">
            <img src="../../../../static/image/no_works.png" alt="" />
            <p>{{ $t('message.home.coll') }}</p>
          </div>
        </van-list>
      </div>
    </div>
    <div class="home" @click="homeClick">
      <van-icon name="wap-home" color="#3562FF" />
    </div>
    <div class="fiex" v-if="showItem">
      <div class="fiex_item" @click="imageClick(3)" v-if="photographyShow">
        <img src="../../../../static/image/icon5.png" alt="" />
        <span>{{ $t('message.explain.photo_con') }}</span>
      </div>
      <div class="fiex_item" @click="imageClick(2)" v-if="videoShow">
        <img src="../../../../static/image/icon7.png" alt="" />
        <span>{{ $t('message.explain.voide_con') }}</span>
      </div>
      <div class="fiex_item" @click="imageClick(4)" v-if="paintingShow">
        <img src="../../../../static/image/icon4.png" alt="" />
        <span>{{ $t('message.explain.pain_con') }}</span>
      </div>
      <div class="fiex_item" @click="imageClick(5)" v-if="comicShow">
        <img src="../../../../static/image/icon2.png" alt="" />
        <span>{{ $t('message.explain.animation_con') }}</span>
      </div>
      <div class="fiex_item" @click="imageClick(6)" v-if="kechuangShow">
        <img src="../../../../static/image/icon3.png" alt="" />
        <span>{{ $t('message.explain.scienfic') }}</span>
      </div>
    </div>
    <div class="goTop" :title="$t('message.home.b_top')" @click="goTop()" v-show="isActive">
      <a href="#topAnchor">
        <van-icon name="back-top" />
      </a>
    </div>
    <tab-bar-view @tabBarClick="tabBarClick" :indexNum="0" />
  </div>
</template>
<script>
import axios from 'axios'
// 引入h5跳小程序
import wx from 'weixin-js-sdk'
const defaultQueryInfo = Object.freeze({
  activityId: '',
  pageNum: 1,
  order: 0,
  pageSize: 10,
  queryKey: 1,
  worksType: '',
  activeSearch: '',
  competitionArea: '',
  language: '',
  awardZhcn: null
})
import { wexinShare } from '@/utils/wxshare'
import { wxShare } from '@/api/common'
import {
  getDetailActivity,
  getSaiqu,
  activeWinningList,
  voteWorks,
  linksSave,
  listByAward,
  listMonthlyFocus,
  listDivisionMonthlyFocus,
  listH5ActiveAward,
  listH5PopularityAward,
  getAccessToken
} from '@/api/activity'
import { Toast } from 'vant'
import { getCookie } from '@/utils/cookie'
import TabBarView from '../../../components/TabBarView.vue'
export default {
  components: { TabBarView },
  name: 'Works',
  beforeRouteLeave(to, from, next) {
    if (to.path == '/activity/details' || to.path == '/activity/award') {
      next()
    }
    next()
  },
  activated() {
    if (
      JSON.parse(sessionStorage.getItem('worksIdList')) != [] &&
      JSON.parse(sessionStorage.getItem('worksIdList')) != '' &&
      JSON.parse(sessionStorage.getItem('worksIdList')) != null
    ) {
      let worksIdList = JSON.parse(sessionStorage.getItem('worksIdList'))
      worksIdList.forEach((item) => {
        for (let i = 0; i < this.dataList.length; i++) {
          if (item == this.dataList[i].id) {
            this.dataList[i].isVote = true
            this.dataList[i].votes += 1
          }
        }
      })
      sessionStorage.removeItem('worksIdList')
    }
    this.$nextTick(() => {
      let works = document.getElementById('works')
      let scrollHeight = works.parentNode
      scrollHeight.scrollTop = this.scroll
    })
  },

  data() {
    return {
      showListImg: false,
      loading: false,
      finished: false,
      loadingAward: false,
      finishedAward: false,
      queryInfo: { ...defaultQueryInfo },
      newWorksAward: false,
      activityData: {
        contributeType: '',
        notShare: false
      },
      navTabList: [],
      navWorksList: [
        {
          name: this.$t('message.home.latest'),
          id: 1
        },
        {
          name: this.$t('message.home.pop_works'),
          id: 2
        },
        {
          name: this.$t('message.home.Award_works'),
          id: 3
        }
      ],
      navWorksIndex: 1,
      navTabIndex: 0,
      navSaiIndex: 0,
      byAwardList: [],
      getByAwardIndex: 0,
      showItem: false,
      imgTextShow: false, //图文
      videoShow: false, //视频
      photographyShow: false, //摄影
      paintingShow: false, //绘画
      comicShow: false, //动漫
      kechuangShow: false, //科创
      musicShow: false, //音乐
      laseClick: true,
      isActive: false,
      tokenShow: false,
      SaiquList: [this.$t('message.home.allreg')],
      dataList: [],
      worksType: 0,
      token: '',
      competitionArea: '',
      isWhether: 1,
      pageindex: 1,
      pageIndexAward: 1,
      awardData: [],
      newIndex: 0,
      searchTime: null,
      idS: [],
      dataS: [],
      awardDataNum: [],
      scroll: 0,
      itemAddWork: '',
      organization: true,
      queryOrganization: {
        activeId: '',
        worksType: '', // 作品类型 1->图文投稿;2->视频投稿;3->摄影类;4->绘画类;5->动漫类;6->科创类;7->音乐
        howManyTheTop: '',
        language: '',
        orders: ''
      },
      organizationList: [],
      divisionList: [],
      awardList: [],
      listActive: 0,
      // 通过分享链接进来的榜单
      listState: false,
      queryAward: {
        activityId: '',
        pageNum: 1,
        pageSize: 10,
        language: '',
        worksType: '',
        activeSearch: '',
        awardZhcn: '',
        conditionsOfVoting: '',
        queryKey: 3
      }
    }
  },

  computed: {
    id() {
      return this.$route.query.id
    },
    organizationId() {
      return this.$route.query.organizationId * 1
    },
    divisionName() {
      return this.$route.query.divisionName
    }
  },
  created() {
    // this.search()
    // 原生小程序跳转 h5页面后获取参数
    // console.log(1111);
    // window.onload = function () {
    //   console.log(window.location.search, '=====>>>>window.location.search');
    //   console.log(window.location, '=====>>>>window.location0000000');
    //   const queryString = window.location.search;
    //   const urlParams = new URLSearchParams(queryString);
    //   console.log(urlParams, '====>>>.urlParams');
    //   const param1 = urlParams.get('param1');
    //   const param2 = urlParams.get('param2');
    //   console.log(param1, param2, '======>>>param1&param2');
    //   // ... 使用这些参数进行页面初始化或其他操作
    //   // window.location.href ===

    // };

    if (this.$route.query.lang) {
      if (this.$route.query.lang == 'zhcn') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', false)
      }
      if (this.$route.query.lang == 'en') {
        sessionStorage.setItem('lang', this.$route.query.lang)
        sessionStorage.setItem('bl', true)
      }
    }
    if (sessionStorage.getItem('awardWorks')) {
      this.queryAward.queryKey = sessionStorage.getItem('navWorksIndex')
      this.navWorksIndex = sessionStorage.getItem('navWorksIndex')
    } else if (sessionStorage.getItem('navWorksIndex')) {
      this.navWorksIndex = sessionStorage.getItem('navWorksIndex')
      this.queryInfo.queryKey = sessionStorage.getItem('navWorksIndex')
    }
    if (sessionStorage.getItem('organizationId') != 0 && sessionStorage.getItem('organizationId')) {
      // this.openLink()
      console.log('h5')
    } else if (this.organizationId) {
      this.openLink()
      sessionStorage.setItem('organizationId', this.organizationId)
    } else {
      sessionStorage.setItem('organizationId', 0)
    }

    if (this.divisionName) {
      sessionStorage.setItem('divisionName', this.divisionName)
      sessionStorage.setItem('divisionNameId', this.id)
    } else if (
      sessionStorage.getItem('divisionName') != '' &&
      sessionStorage.getItem('divisionName')
    ) {
      console.log('h5')
    } else {
      sessionStorage.setItem('divisionName', '')
    }

    this.token = getCookie('token')
    if (this.token) {
      this.tokenShow = true
    } else {
      this.tokenShow = false
    }
    this.getByAwardList()
    this.getActivityData()
    this.getListShow()
    // this.getListMonthlyFocus()
    // this.getListMonthlyFocusDivision()
    // this.search()
    this.weixin()

    // h5-小程序（测试）
    // this.getConfig()
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll, true)
    // 挂载时触发一次
    // document.addEventListener('visibilitychange', this.visiableChange)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    //  隐藏时触发一次
    // document.removeEventListener('visibilitychange', this.visiableChange)
  },
  filters: {
    lift(value) {
      let str = value + ''
      return str.split('-')[1]
    }
  },
  methods: {
    // // 当页面在浏览器显示或者隐藏时触发
    // visiableChange(e) {
    //   // console.log(e, '======>e');
    //   switch (e.target.visibilityState) {
    //     case 'hidden':
    //       // console.log('页面隐藏或者最小化')
    //       break
    //     case 'visible':
    //       // 请求列表操作
    //       // =========>
    //       this.getByAwardList()
    //       this.getActivityData()
    //       this.getListShow()
    //       // this.getListMonthlyFocus()
    //       // this.getListMonthlyFocusDivision()
    //       // this.search()
    //       this.weixin()
    //       break
    //   }
    // },
    // 通过链接进来调起接口
    async openLink() {
      const { data } = await linksSave({
        organizationId: this.organizationId,
        activeId: this.id * 1
      })
      if (data.resultCode == 200) {
        console.log(data)
      }
    },
    async weixin() {
      var urls = window.location.href
      var title = ''
      var desc = ''
      const { data: res } = await wxShare({ url: urls })
      if (res.code == 102400) {
        if (this.activityData.notShare) {
          //yuanjing   元景云摄影大赛平台
          // title = this.$t('message.home.yuanjing')
          // 机构榜单分享
          if (this.navWorksIndex == 4) {
            // 0 赛区榜   1机构榜
            if (this.listActive == 0) {
              title = '影像中国赛区参与度榜单'
            } else if (this.listActive == 1) {
              title = '影像中国机构参与度榜单'
            }
          } else {
            title = this.$t('message.home.yuanjing')
          }
          desc = this.$t('message.home.china_yuanjing')
        } else {
          if (this.navWorksIndex == 4) {
            if (this.listActive == 0) {
              title = '欢迎参加' + this.activityData.activeName + '赛区参与度榜单'
            } else if (this.listActive == 1) {
              title = '欢迎参加' + this.activityData.activeName + '机构参与度榜单'
            }
          } else {
            title = '欢迎参加' + this.activityData.activeName ? this.activityData.activeName : ''
          }

          desc = this.$t('message.home.p_yuanjing')
        }

        var obj = {
          appId: res.appId,
          nonceStr: res.nonceStr,
          signature: res.signature,
          timestamp: res.timestamp,
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData']
        }
        let shareData = {
          title: title, // 分享标题
          desc: desc,
          link: urls,
          imgUrl:
            'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/%E5%85%83%E6%99%AF%E4%BA%91logo-01.png' // 分享图标
        }
        // 3 是 获奖 4 是绑定
        if (this.navWorksIndex == 3) {
          console.log(this.itemAddWork)
          shareData = {
            title: title, // 分享标题
            desc: desc,
            link: urls.split('&')[0] + '&awardWorks=' + encodeURI(this.itemAddWork),
            // awardLink: this.itemAddWork,
            // link: window.location.href,
            imgUrl:
              'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/%E5%85%83%E6%99%AF%E4%BA%91logo-01.png' // 分享图标
          }
        } else if (this.navWorksIndex == 4) {
          shareData = {
            title: title, // 分享标题
            desc: desc,
            link:
              urls.split('&')[0] + '&list=' + this.navTabIndex + '&listActive=' + this.listActive,
            // 携带当前的作品类型
            // list: this.navTabIndex,
            // listActive: this.listActive,
            imgUrl:
              'https://imagecharacter.oss-cn-beijing.aliyuncs.com/image_data/%E5%85%83%E6%99%AF%E4%BA%91logo-01.png' // 分享图标
          }
        }
        // console.log(this.navWorksIndex)
        // console.log(shareData.link)
        // alert(shareData.link)
        wexinShare(obj, shareData)
      }
    },
    clickListTabItem(index) {
      this.listActive = index
      this.weixin()
    },
    voteClickNo(item, index) {
      Toast.fail(this.$t('message.home.p_yuanjing'))
    },
    getDiffDay(date_1, date_2) {
      // 计算两个日期之间的差值
      let totalDays, diffDate
      let myDate_1 = Date.parse(date_1)
      // let myDate_2 = Date.parse(date_2)
      let myDate_2 = Date.parse(new Date())
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(myDate_1 - myDate_2) // 取相差毫秒数的绝对值
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)) // 向下取整
      return totalDays // 相差的天数
    },
    // 点击投票后 进行投票携带url
    // 这是投票的时间

    // 点击刚刚那个之后会跳转小程序
    async voteListClick(row, index) {
      const now = 86400000
      const bol =
        Date.parse(new Date()) - Date.parse(new Date(this.activityData.activeEndTime)) > now * 7
      if (bol) {
        return Toast.fail(this.$t('message.home.voting_tips'))
      }
      const worksPraise = {
        worksId: row.id,
        conditionsOfVoting: this.activityData.conditionsOfVoting
      }
      await getAccessToken({
        userId: sessionStorage.getItem('userId'),
        activeId: this.queryOrganization.activeId,
        schema: sessionStorage.getItem('schema')
      })
      const { data: res } = await voteWorks(worksPraise)
      if (res.resultCode === 200) {
        // 新获奖作品  // newWorksAward 是true  表示当前是在获奖作品状态
        if (this.newWorksAward) {
          this.awardData[index].isVote = true
          this.awardData[index].votes += 1
        } else {
          this.dataList[index].isVote = true
          this.dataList[index].votes += 1
        }
        // this.pageindex = 1
        // this.dataList = []
        // this.search()
        Toast.success(this.$t('message.home.succ_vote'))
        // this.getActivityData()
        // this.getListShow()
      } else {
        Toast.fail(this.$t('message.home.network'))
      }
    },
    // 获取赛区数据
    async getListMonthlyFocusDivision(tr) {
      if (tr) {
        this.queryOrganization.worksType = this.navTabIndex
      } else if (this.listState) {
        this.queryOrganization.worksType = this.navTabIndex
      } else {
        // this.queryOrganization.worksType = this.activityData.contributeTypeList[0]
        this.queryOrganization.worksType = this.navTabList[0].id
      }
      this.queryOrganization.activeId = this.id
      const { data: res } = await listDivisionMonthlyFocus(this.queryOrganization)
      // const { data: res } = await listDivisionMonthlyFocus(this.queryOrganization)
      if (res.resultCode == 200) {
        this.divisionList = res.data
      }
    },
    // 获取榜单数据
    async getListMonthlyFocus(tr) {
      // 1 点击切换的时候的索引值
      // 2 分享出去后再重新进来  拿到的索引值
      // 3 第一次进来  默认要拿接口返回的第一个值
      if (tr) {
        this.queryOrganization.worksType = this.navTabIndex
      } else if (this.listState) {
        this.queryOrganization.worksType = this.navTabIndex
      } else {
        // this.queryOrganization.worksType = this.activityData.contributeTypeList[0]
        this.queryOrganization.worksType = this.navTabList[0].id
      }
      this.queryOrganization.activeId = this.id
      const { data: res } = await listMonthlyFocus(this.queryOrganization)
      // const { data: res } = await listDivisionMonthlyFocus(this.queryOrganization)
      if (res.resultCode == 200) {
        this.organizationList = res.data
      }
    },
    // 手机端h5 (notPersonDay-true 今日广告次数没有了  notVideoVotes-true 投票次数没有了)
    async voteClick(row, index) {
      let token = getCookie('token')
      if (!token) {
        this.$router.replace('/login')
        return Toast.fail('您未登录，请登录')
      } else {
        // 是否开启广告入口(默认0) 0->未开启;1->开启
        if (row.exportAdvertising) {
          const worksPraise = {
            worksId: row.id,
            conditionsOfVoting: this.activityData.conditionsOfVoting
          }
          const { data: res } = await voteWorks(worksPraise)
          // 根据message判断是否达到上限
          if (res.resultCode === 500 && res.data === 10510) {
            if (res.message === '当天观看次数已达到上限。') {
              Toast.fail(res.message)
            } else {
              Toast.fail('今日投票次数没有了，为你观看广告获取投票次数')
              const { data: res1 } = await getAccessToken({
                userId: getCookie('userId'),
                activeId: this.queryOrganization.activeId,
                schema: sessionStorage.getItem('schema')
              })
              if (res1.resultCode === 200) {
                window.location.href = res1.data
              }
            }
          } else {
            // 新获奖作品  // newWorksAward 是true  表示当前是在获奖作品状态
            if (this.newWorksAward) {
              this.awardData[index].isVote = true
              this.awardData[index].votes += 1
            } else {
              this.dataList[index].isVote = true
              this.dataList[index].votes += 1
            }
            Toast.success(this.$t('message.home.succ_vote'))
          }
        } else {
          this.voteListClick(row, index)
        }
      }

      // // 广告入口已开启
      // if (row.exportAdvertising) {
      //   // notPersonDay为true -- 今日广告次数没有了
      //   if (row.notPersonDay) {
      //     Toast.fail('今日广告次数没有了')
      //     return
      //   }
      //   // notVideoVotes为true -- 今日投票次数没有了，提醒去看广告
      //   if (!row.notVideoVotes) {
      //     Toast.fail('今日投票次数没有了，为你观看广告获取投票次数')
      //     const { data: res } = await getAccessToken({
      //       userId: sessionStorage.getItem('userId'),
      //       activeId: this.queryOrganization.activeId,
      //       schema: sessionStorage.getItem('schema')
      //     })
      //     if (res.resultCode === 200) {
      //       window.location.href = res.data
      //     }
      //   } else {
      //     if (getCookie('token')) {
      //       this.voteListClick(row, index)
      //       // 投完票之后将状态值改为今日没有广告次数
      //       row.notVideoVotes = true
      //     } else {
      //       Toast.fail(this.$t('message.home.log_first'))
      //       setTimeout(() => {
      //         this.$router.push({
      //           name: 'Login'
      //         })
      //       }, 1000)
      //     }
      //   }
      // } else {
      //   if (getCookie('token')) {
      //     this.voteListClick(row, index)
      //   } else {
      //     Toast.fail(this.$t('message.home.log_first'))
      //     setTimeout(() => {
      //       this.$router.push({
      //         name: 'Login'
      //       })
      //     }, 1000)
      //   }
      // }
    },
    searchClick() {
      this.$router.push({
        name: 'searchList',
        query: {
          activityId: this.queryInfo.activityId,
          competitionArea: this.queryInfo.competitionArea,
          worksType: this.queryInfo.worksType,
          queryKey: this.queryInfo.queryKey,
          conditionsOfVoting: this.activityData.conditionsOfVoting
        }
      })
    },
    homeClick() {
      sessionStorage.removeItem('navWorksIndex')
      sessionStorage.removeItem('awardWorks')
      this.$router.push({
        name: 'Activity'
      })
    },
    detailsClick(row) {
      console.log('这是点击了啥？')
      this.idS = []
      // console.log(this.idS);
      this.dataList.forEach((item, index) => {
        this.idS.push(item.id)
      })
      // 拿到当前id  和所有id进行比较  然后在去除这个id
      let idx = null
      this.idS.forEach((item, id) => {
        if (row.id == item) {
          return (idx = id)
        }
      })
      if (idx != null) {
        this.idS = this.idS.slice(idx + 1)
      }
      sessionStorage.setItem('navWorksIndex', this.navWorksIndex)
      this.$route.meta.keepAlive = true
      if (this.navWorksIndex == 3) {
        this.$router.push({
          name: 'worksDetails',
          query: {
            id: row.id,
            queryInfo: JSON.stringify(this.queryInfo),
            pageNum: this.queryInfo.pageNum,
            idS: JSON.stringify(this.idS),
            pages: this.dataS.pages,
            conditionsOfVoting: this.activityData.conditionsOfVoting,
            activeEndTime: this.activityData.activeEndTime,
            showPrize: true,
            prizeName: this.getByAwardIndex == -1 ? this.$t('message.popularityAward') : ''
          }
        })
      } else {
        this.$router.push({
          name: 'worksDetails',
          query: {
            id: row.id,
            queryInfo: JSON.stringify(this.queryInfo),
            pageNum: this.queryInfo.pageNum,
            idS: JSON.stringify(this.idS),
            pages: this.dataS.pages,
            conditionsOfVoting: this.activityData.conditionsOfVoting,
            activeEndTime: this.activityData.activeEndTime
          }
        })
        // console.log(, 'ahhhhhh');
      }
    },

    awardDetailsClick(row) {
      console.log(11)
      this.idS = []
      // console.log(this.idS);
      this.awardData.forEach((item, index) => {
        this.idS.push(item.id)
      })
      // 拿到当前id  和所有id进行比较  然后在去除这个id
      let idx = null
      this.idS.forEach((item, id) => {
        if (row.id == item) {
          return (idx = id)
        }
      })
      if (idx != null) {
        this.idS = this.idS.slice(idx + 1)
      }
      sessionStorage.setItem('navWorksIndex', this.navWorksIndex)
      sessionStorage.setItem('awardWorks', true)
      this.$route.meta.keepAlive = true
      // alert(this.activityData.conditionsOfVoting)
      this.$router.push({
        name: 'worksDetails',
        query: {
          id: row.id,
          queryInfo: JSON.stringify(this.queryAward),
          pageNum: this.queryAward.pageNum,
          idS: JSON.stringify(this.idS),
          pages: this.awardDataNum.pages,
          conditionsOfVoting: this.activityData.conditionsOfVoting,
          showPrize: true,
          prizeName: this.getByAwardIndex == -1 ? this.$t('message.popularityAward') : ''
        }
      })
    },
    navHeaClick(index) {
      // console.log(123);
      this.showItem = false
      this.laseClick = true
      this.pageindex = 1
      this.pageIndexAward = 1
      this.dataList = []
      this.navTabIndex = index
      this.finished = false

      // 新获奖作品  // newWorksAward 是true  表示当前是在获奖作品状态
      if (this.newWorksAward) {
        this.awardList = []
        this.awardData = []
        if (this.getByAwardIndex == -1) {
          this.getPopularityAward()
        } else {
          this.getAward()
        }
      } else {
        this.getListMonthlyFocus(true)
        this.getListMonthlyFocusDivision(true)
        this.search()
      }
      this.weixin()
    },
    navListClick(index) {
      if (this.loading) {
        return
      }

      if (index == 1 || index == 2 || index == 4) {
        this.queryInfo.awardZhcn = null
      }
      sessionStorage.removeItem('awardWorks')
      this.newWorksAward = false
      this.organization = true
      this.pageindex = 1
      this.dataList = []
      this.navWorksIndex = index
      this.queryInfo.queryKey = index

      this.finished = false
      // 获奖
      this.newWorksAward = false
      this.weixin()
      this.search()
    },
    // 新获奖作品排版
    awardWorksClick(index) {
      // console.log(index, 'index')
      this.navWorksIndex = index
      this.queryAward.queryKey = index
      this.pageIndexAward = 1
      this.awardList = []
      this.newWorksAward = true
      this.organization = false
      this.weixin()

      if (this.getByAwardIndex == -1) {
        this.awardData = []
        this.getPopularityAward()
      } else {
        this.awardData = []
        this.getAward()
      }
    },
    //
    clickOrganization(index) {
      this.navWorksIndex = index
      this.organization = false
      this.newWorksAward = false
      sessionStorage.removeItem('awardWorks')
      this.weixin()
    },

    saiQuClick(index) {
      this.pageindex = 1
      this.dataList = []
      this.navSaiIndex = index
      if (index === 0) {
        this.queryInfo.competitionArea = ''
      } else {
        this.queryInfo.competitionArea = this.SaiquList[index]
      }
      this.finished = false
      this.search()
    },
    // 获取人气奖数据前置事件
    clickPopularityAward(item, index) {
      // console.log('clickPopularityAward')
      this.pageIndexAward = 1
      this.awardData = []
      this.awardList = []
      this.getByAwardIndex = index
      // console.log(item)
      if (index === 0) {
        this.queryAward.awardZhcn = null
        this.queryAward.activeSearch = ''
      } else {
        this.queryAward.awardZhcn = item.id
        this.queryAward.activeSearch = item.addWork
      }
      this.itemAddWork = item.addWork
      // console.log(this.itemAddWork)
      this.finishedAward = false
      // this.search()
      this.getPopularityAward()
      this.weixin()
    },
    clickByAward(item, index) {
      this.pageIndexAward = 1
      this.awardData = []
      this.awardList = []
      this.getByAwardIndex = index
      console.log(item)
      if (index === 0) {
        this.queryAward.awardZhcn = null
        this.queryAward.activeSearch = ''
      } else {
        this.queryAward.awardZhcn = item.id
        this.queryAward.activeSearch = item.addWork
      }

      this.itemAddWork = item.addWork
      // console.log(this.itemAddWork)
      this.finishedAward = false
      // this.search()
      if (this.getByAwardIndex == -1) {
        this.getPopularityAward()
      } else {
        this.getAward()
      }
      this.weixin()
    },
    async getByAwardList() {
      let query = {
        activeId: this.id,
        language: sessionStorage.getItem('lang')
      }
      const { data: res } = await listByAward(query)
      // console.log(res)
      if (res.resultCode == 200) {
        this.byAwardList = res.data
        this.byAwardList.unshift({
          addWork: this.$t('message.home.i_all'),
          id: '-1'
        })
        // 获奖进来分享
        let link = decodeURI(this.$route.query.awardWorks)

        if (Object.prototype.toString.call(this.$route.query.awardWorks) == '[object Array]') {
          this.byAwardList.forEach((item, index) => {
            // -1 是全部 搜索全部传null
            if (link.split(',')[0] == item.addWork) {
              if (item.id == '-1') {
                this.queryInfo.awardZhcn = null
              } else {
                this.queryInfo.awardZhcn = item.id
                this.itemAddWork = item.addWork
              }

              this.getByAwardIndex = index
              // 这个是选择到获奖作品
              this.navWorksIndex = 3
              // 这个是请求的时候是请求获奖作品这个类型的
              this.queryInfo.queryKey = 3
            }
          })
        } else if (link) {
          // console.log(link);
          // console.log(this.byAwardList);
          this.byAwardList.forEach((item, index) => {
            // -1 是全部 搜索全部传null
            if (link == item.addWork) {
              if (item.id == '-1') {
                this.queryInfo.awardZhcn = null
              } else {
                this.queryInfo.awardZhcn = item.id
                this.itemAddWork = item.addWork
              }

              this.getByAwardIndex = index
              // 这个是选择到获奖作品
              this.navWorksIndex = 3
              // 这个是请求的时候是请求获奖作品这个类型的
              this.queryInfo.queryKey = 3
            }
          })
        } else if (link == '') {
          this.queryInfo.awardZhcn = null
          // this.getByAwardIndex = 0
          if (this.activityData.isPopularityAward) {
            this.getByAwardIndex = -1
          }
          if (this.activityData.isWorkShow) {
            this.getByAwardIndex = 0
          }

          this.navWorksIndex = 3
          this.queryInfo.queryKey = 3
        }
        // let list = this.$route.query.list
        // 榜单进来
        // if (list) {
        //   this.listState = true
        //   this.organization = false
        //   this.navWorksIndex = 4
        //   // this.navTabIndex = list * 1
        //   // console.log(this.navTabIndex)
        // }
      }
    },
    // 获奖投票点击
    awardVoteClick(item, index) {
      if (getCookie('token')) {
        this.voteListClick(item, index)
      } else {
        Toast.fail(this.$t('message.home.log_first'))
        setTimeout(() => {
          this.$router.push({
            name: 'Login'
          })
        }, 1000)
      }
    },
    arrDuplicateRemoval(arr, id) {
      const res = new Map()
      return arr.filter((arr) => !res.has(arr[id]) && res.set(arr[id], 1))
    },
    async search() {
      this.loading = true
      if (this.newIndex === 0) {
        this.newIndex++
        return
      }

      this.queryInfo.activityId = this.id
      this.queryInfo.worksType = this.navTabIndex
      this.queryInfo.pageNum = this.pageindex
      this.queryInfo.language = sessionStorage.getItem('lang')
        ? sessionStorage.getItem('lang')
        : 'zhcn'
      this.queryInfo.conditionsOfVoting = this.activityData.conditionsOfVoting

      const { data: res } = await activeWinningList(this.queryInfo)
      if (res.resultCode === 200) {
        this.dataList = [...this.dataList, ...res.data.list]
        this.dataList = this.arrDuplicateRemoval(this.dataList, 'id')
        // this.dataList.forEach((item, index) => {
        //   if (
        //     this.dataList[index].votes == 0 ||
        //     this.dataList[index].votes == null ||
        //     this.dataList[index].votes == ''
        //   ) {
        //     this.dataList[index].votes += 1
        //   } else if (this.dataList[index].votes * 1 > 0) {
        //     this.dataList[index].votes += 1
        //   }
        // })

        this.dataS = res.data
        this.loading = false
        if (res.data.hasNextPage) {
          this.pageindex++
        } else {
          this.finished = true
        }
        if (this.dataList.length > 0) {
          this.showListImg = false
        } else {
          this.showListImg = true
        }
      } else {
        this.finished = true
        this.loading = false
      }
    },

    async getListShow() {
      const { data: res } = await getSaiqu({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang')
      })
      // console.log(res.data)
      if (res.resultCode === 200) {
        if (res.data) {
          if (res.data.length == 1) {
            this.SaiquList = res.data
          } else {
            this.SaiquList = this.SaiquList.concat(res.data)
          }
          // console.log(this.navWorksIndex)
          let i = this.SaiquList.indexOf(this.$route.query.divisionName)
          if (i != -1) {
            this.navSaiIndex = i
            this.queryInfo.competitionArea = this.SaiquList[i]
          } else {
            this.queryInfo.competitionArea = ''
            this.navSaiIndex = 0
          }

          // console.log(this.navSaiIndex)
        }
      }
    },
    goTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    handleScroll(e) {
      let works = document.getElementById('works')
      if (works) {
        let scrollHeight = works.parentNode
        this.$nextTick(() => {
          this.scroll = scrollHeight.scrollTop
        })
      }

      if (e.target.scrollTop > 200) {
        this.isActive = true
        this.scroll = e.target.scrollTop
      } else {
        this.isActive = false
      }
    },
    async getActivityData() {
      // const url = 'https://imagecharacter.oss-cn-beijing.aliyuncs.com/'
      let divisionName = ''

      if (sessionStorage.getItem('divisionNameId') == this.id) {
        divisionName =
          sessionStorage.getItem('divisionName') == '' ? '' : sessionStorage.getItem('divisionName')
      } else {
        divisionName = ''
      }
      const { data: res } = await getDetailActivity({
        id: this.id,
        language:
          sessionStorage.getItem('lang') == undefined ? 'zhcn' : sessionStorage.getItem('lang'),
        divisionName: divisionName
      })
      if (res.resultCode === 200) {
        this.isWhether = res.data.isWhether
        // res.data.activeImageList = res.data.activeImageList.map((el) => {
        //   return url + el
        // })
        Object.assign(this.activityData, res.data)
        this.activityData.conditionsOfVoting = this.activityData.conditionsOfVoting
          ? this.activityData.conditionsOfVoting
          : 1
        if (this.activityData.isPopularityAward) {
          this.getByAwardIndex = -1
        }
        if (this.activityData.isWorkShow) {
          this.getByAwardIndex = 0
        }

        // this.activityData = res.data
        let str = this.activityData.contributeType
        if (str.indexOf('1') >= 0) {
          this.imgTextShow = true
        }

        if (str.indexOf('3') >= 0) {
          this.photographyShow = true
          this.navTabList.push({
            name: this.$t('message.explain.photo'),
            id: 3
          })
        }
        if (str.indexOf('2') >= 0) {
          this.videoShow = true
          this.navTabList.push({
            name: this.$t('message.explain.voide'),
            id: 2
          })
        }

        if (str.indexOf('4') >= 0) {
          this.paintingShow = true
          this.navTabList.push({
            name: this.$t('message.explain.pain'),
            id: 4
          })
        }
        if (str.indexOf('5') >= 0) {
          this.comicShow = true
          this.navTabList.push({
            name: this.$t('message.explain.animation'),
            id: 5
          })
        }
        if (str.indexOf('6') >= 0) {
          this.kechuangShow = true
          this.navTabList.push({
            name: this.$t('message.explain.sci_work'),
            id: 6
          })
        }
        if (str.indexOf('7') >= 0) {
          this.musicShow = true
          this.navTabList.push({
            name: this.$t('message.explain.sci_music'),
            id: 7
          })
        }
        if (
          this.activityData.monthlyFocus == true &&
          this.activityData.divisionMonthlyFocus == false
        ) {
          this.listActive = 1
        }

        let list = this.$route.query.list
        // console.log(list)
        if (Object.prototype.toString.call(list) == '[object Array]') {
          this.listState = true
          this.navTabIndex = list[0]
          this.organization = false
          this.navWorksIndex = 4

          // if (this.$route.query.listActive) {
          this.listActive = this.$route.query.listActive[0]
          // }
        } else if (Object.prototype.toString.call(list) == '[object String]') {
          this.listState = true
          this.navTabIndex = list
          this.organization = false
          this.navWorksIndex = 4
          this.listActive = this.$route.query.listActive
        } else {
          // console.log(this.navTabList[0].id)
          // console.log(res.data.contributeType.split(',')[0])
          this.navTabIndex = this.navTabList[0].id
        }
        // this.getListMonthlyFocus()
        // this.getListMonthlyFocusDivision()
        // this.search()
        // this.weixin()
      }
      this.getListMonthlyFocus()
      this.getListMonthlyFocusDivision()
      if (sessionStorage.getItem('awardWorks')) {
        // console.log(1)
        this.newWorksAward = true
        this.organization = false
        this.navWorksIndex = 3
      }
      if (this.getByAwardIndex == -1) {
        this.getPopularityAward()
      } else {
        this.getAward()
      }
      this.search()

      this.weixin()
    },
    // 获取获奖作品数据
    async getAward() {
      this.loadingAward = true

      this.queryAward.activityId = this.id
      this.queryAward.worksType = this.navTabIndex
      this.queryAward.pageNum = this.pageIndexAward
      this.queryAward.language = sessionStorage.getItem('lang')
        ? sessionStorage.getItem('lang')
        : 'zhcn'
      this.queryAward.conditionsOfVoting = this.activityData.conditionsOfVoting
      const { data: res } = await listH5ActiveAward(this.queryAward)

      if (res.resultCode == 200) {
        this.awardData = [...this.awardData, ...res.data.list]
        this.awardDataNum = res.data
        res.data.list.forEach((item, index) => {
          if (!this.awardList.includes(item.addWork)) {
            this.awardList.push(item.addWork)
          }
        })
        this.loadingAward = false
        if (res.data.hasNextPage) {
          this.pageIndexAward++
        } else {
          this.finishedAward = true
        }
      } else {
        this.finishedAward = true
        this.loadingAward = false
      }
      // 控制渲染作品奖项的顺序和头部奖项切换栏一致
      let headerList = this.byAwardList.filter((el) =>
        this.awardList.find((ele) => el.addWork == ele)
      )
      // headerList为空就代表是不存在就没必要进行这一步
      if (headerList.length) {
        headerList = headerList.map((el) => el.addWork)
      }
      this.awardList = headerList
      // console.log(this.awardList)

      // console.log(list)
    },
    // 获取获奖作品数据
    async getPopularityAward() {
      this.loadingAward = true
      console.log(this.awardData, 'awardData')

      this.queryAward.activityId = this.id
      this.queryAward.worksType = this.navTabIndex
      this.queryAward.pageNum = this.pageIndexAward
      this.queryAward.language = sessionStorage.getItem('lang')
        ? sessionStorage.getItem('lang')
        : 'zhcn'
      this.queryAward.conditionsOfVoting = this.activityData.conditionsOfVoting
      const { data: res } = await listH5PopularityAward(this.queryAward)

      if (res.resultCode == 200) {
        this.awardData = [...this.awardData, ...res.data.list]
        console.log(this.awardData, 'awardData')
        this.awardDataNum = res.data
        res.data.list.forEach((item, index) => {
          if (!this.awardList.includes(item.addWork)) {
            this.awardList.push(item.addWork)
          }
        })
        this.loadingAward = false
        if (res.data.hasNextPage) {
          this.pageIndexAward++
        } else {
          this.finishedAward = true
        }
      } else {
        this.finishedAward = true
        this.loadingAward = false
      }
      // console.log(this.awardList)

      // console.log(list)
    },
    // 获奖作品详情
    awardDetails() {},
    imageClick(index) {
      this.showItem = false
      // 3==>"摄影类投稿"   2==>"视频类投稿"   4==>"绘画类投稿"  6==> "科创类投稿"

      if (index == 3) {
        if (this.activityData.notSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        }
      } else if (index == 2) {
        if (this.activityData.notVideoSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        }
      } else if (index == 4) {
        if (this.activityData.notPaintingSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        }
      } else if (index == 6) {
        if (this.activityData.notKeChangeSignUp) {
          this.$router.push({
            name: 'SignUp',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        } else {
          this.$router.push({
            name: 'UploadWorks',
            query: { id: this.id, index: index, isWhether: this.isWhether }
          })
        }
      }

      // console.log('```````````````');
      // this.$router.push({
      //   name: 'UploadWorks',
      //   query: { id: this.id, index: index, isWhether: this.isWhether }
      // })
      // if (this.activityData.notSignUp) {
      //   this.$router.push({
      //     name: 'SignUp',
      //     query: { id: this.id, index: index, isWhether: this.isWhether }
      //   })
      // } else {
      //   this.$router.push({
      //     name: 'UploadWorks',
      //     query: { id: this.id, index: index, isWhether: this.isWhether }
      //   })
      // }
    },
    tabBarClick(val) {
      if (val == 0) {
        this.$router.push({
          name: 'Works',
          query: { id: this.id }
        })
      } else if (val == 1) {
        if (this.activityData.activeState === 1) {
          return Toast.fail(this.$t('message.home.event_start'))
        } else if (this.activityData.activeState === 3) {
          return Toast.fail(this.$t('message.home.event_ended'))
        }
        let token = getCookie('token')
        if (token) {
          if (this.activityData.contributeTypeList.length === 1) {
            if (this.activityData.notSignUp) {
              if (this.activityData.activeState === 3) {
                Toast.fail(this.$t('message.home.event_ended'))
              } else {
                this.$router.push({
                  name: 'SignUp',
                  query: {
                    id: this.id,
                    index: this.activityData.contributeTypeList[0],
                    isWhether: this.isWhether
                  }
                })
              }
            } else {
              if (this.activityData.activeState === 3) {
                Toast.fail(this.$t('message.home.event_ended'))
              } else {
                this.$router.push({
                  name: 'UploadWorks',
                  query: {
                    id: this.id,
                    index: this.activityData.contributeTypeList[0],
                    isWhether: this.isWhether
                  }
                })
              }
            }
          } else {
            if (this.activityData.activeState === 2) {
              if (this.laseClick) {
                this.showItem = true
                this.laseClick = false
              } else {
                this.showItem = false
                this.laseClick = true
              }
            } else if (this.activityData.activeState === 1) {
              Toast.fail(this.$t('message.home.event_start'))
            } else if (this.activityData.activeState === 3) {
              Toast.fail(this.$t('message.home.event_ended'))
            }
          }
        } else {
          Toast.fail(this.$t('message.home.first_log'))
          setTimeout(() => {
            this.$router.push({
              name: 'Login'
            })
          }, 1000)
        }
      } else if (val == 2) {
        this.$router.push({
          name: 'ActivityDetails',
          query: { id: this.id }
        })
      }
    },
    onClickLeft() {
      this.$router.push({
        name: 'Activity'
      })
    },
    // 点击赛区榜去投稿
    clickToContribute(item, index) {
      // console.log(item);
      // console.log(this.SaiquList);
      // console.log(this.navSaiIndex);
      // console.log(this.SaiquList.indexOf(item.divisionName));
      this.navSaiIndex = this.SaiquList.indexOf(item.divisionName)
      this.queryInfo.competitionArea = item.divisionName
      this.navListClick(1)
      // let token = getCookie('token')
      // if (!token) {
      //   Toast.fail(this.$t('message.home.first_log'))
      //   this.showItem = false
      //   setTimeout(() => {
      //     this.$router.push({
      //       path: '/login/info'
      //     })
      //   }, 1000)

      //   return
      // }
      // if (this.navTabIndex == 3) {
      //   if (this.activityData.notSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 2) {
      //   if (this.activityData.notVideoSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 4) {
      //   if (this.activityData.notPaintingSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 6) {
      //   if (this.activityData.notKeChangeSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName
      //       }
      //     })
      //   }
      // }
    },
    clickToContributeTwo(item) {
      this.navSaiIndex = this.SaiquList.indexOf(item.divisionName)
      this.queryInfo.competitionArea = item.divisionName
      this.navListClick(1)
      // let token = getCookie('token')
      // if (!token) {
      //   Toast.fail(this.$t('message.home.first_log'))
      //   this.showItem = false
      //   setTimeout(() => {
      //     this.$router.push({
      //       path: '/login/info'
      //     })
      //   }, 1000)

      //   return
      // }
      // // console.log(item)
      // // console.log(item.organizationId);
      // if (this.navTabIndex == 3) {
      //   if (this.activityData.notSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 2) {
      //   if (this.activityData.notVideoSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 4) {
      //   if (this.activityData.notPaintingSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // } else if (this.navTabIndex == 6) {
      //   if (this.activityData.notKeChangeSignUp) {
      //     this.$router.push({
      //       name: 'SignUp',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   } else {
      //     this.$router.push({
      //       name: 'UploadWorks',
      //       query: {
      //         id: this.id,
      //         index: this.navTabIndex,
      //         isWhether: this.isWhether,
      //         divisionName: item.divisionName,
      //         organizationId: item.organizationId
      //       }
      //     })
      //   }
      // }
    },

    //---------------------------------------------------测试
    // 微信跳转小程序-进行配置
    config({ appId, timestamp, nonceStr, signature }) {
      wx.config({
        debug: true, // 开发的时候打开调试，配置过程会弹窗提示你配置的情况
        appId,
        timestamp,
        nonceStr,
        signature,
        jsApiList: [
          'wx-open-launch-weapp', // 跳转小程序
          'getLocation', // 获取定位信息
          'openLocation', // 导航
          'onMenuShareAppMessage', // 分享给朋友
          'onMenuShareTimeline', // 分享到朋友圈
          'onMenuShareQQ', // 分享到QQ
          'onMenuShareQZone', // 分享到QQ空间
          'checkJsApi' // 判断当前客户端版本是否支持指定JS接口
        ],
        openTagList: ['wx-open-launch-weapp', 'wx-open-launch-app'] //打开的标签名
      })
      wx.ready(function () {
        console.log('config is success')
      })
      wx.error(function (err) {
        console.log(err)
      })
    },

    getConfig() {
      let urls = 'https://h5.cnsmeta.cn/'
      let params = { url: urls }
      axios({
        method: 'get',
        url: 'https://www.cnsmeta.cn/api/wxShare/getShare',
        params
      }).then((res) => {
        const { code, appId, nonceStr, signature, timestamp } = res.data
        if (code == 102400) {
          wx.config({
            debug: false, // 开发的时候打开调试，配置过程会弹窗提示你配置的情况
            appId,
            timestamp,
            nonceStr,
            signature,
            jsApiList: [
              'wx-open-launch-weapp', // 跳转小程序
              'onMenuShareAppMessage', // 分享给朋友
              'onMenuShareTimeline', // 分享到朋友圈
              'onMenuShareQQ', // 分享到QQ
              'onMenuShareQZone', // 分享到QQ空间
              'checkJsApi' // 判断当前客户端版本是否支持指定JS接口
            ],
            openTagList: ['wx-open-launch-weapp'] //打开的标签名
          })
          wx.ready(function () {
            // console.log(wx)
          })
          wx.error(function (err) {
            // alert(err)
          })
        }
      })
    }

    // getConfig() {
    //   // var host_url = window.location.host
    //   if (typeof wx != undefined) {
    //     let urls = 'https://h5.cnsmeta.cn/'
    //     let params = { url: urls }
    //     axios({
    //       method: 'get',
    //       url: 'https://www.cnsmeta.cn/api/wxShare/getShare',
    //       params
    //     }).then((res) => {
    //       const { code, appId, nonceStr, signature, timestamp } = res.data
    //       if (code == 102400) {
    //         wx.config({
    //           debug: true, // 开发的时候打开调试，配置过程会弹窗提示你配置的情况
    //           appId,
    //           timestamp,
    //           nonceStr,
    //           signature,
    //           jsApiList: [
    //             'wx-open-launch-weapp', // 跳转小程序
    //             'onMenuShareAppMessage', // 分享给朋友
    //             'onMenuShareTimeline', // 分享到朋友圈
    //             'onMenuShareQQ', // 分享到QQ
    //             'onMenuShareQZone', // 分享到QQ空间
    //             'checkJsApi' // 判断当前客户端版本是否支持指定JS接口
    //           ],
    //           openTagList: ['wx-open-launch-weapp'] //打开的标签名
    //         })
    //         wx.ready(function () {
    //           alert(wx)
    //         })
    //         wx.error(function (err) {
    //           alert(err)
    //         })
    //       }
    //     })
    //   } else {
    //     // 不在微信环境内，可以给出提示或者跳转到其他页面
    //     // alert('请在微信环境内打开H5页面后再尝试操作！')
    //   }
    // }
  }
}
</script>

<style lang="less" scoped>
// 机构办单排名字体
@font-face {
  font-family: YouSheBiaoTiHei;
  src: url('../../../../static/font/YouSheBiaoTiHei-2.ttf');
  font-weight: normal;
  font-style: normal;
}

.works {
  width: 100%;
  overflow: hidden;

  /deep/ .van-list__finished-text {
    width: 100%;
    text-align: center;
  }

  .data_list_img_show {
    width: 100%;
    overflow: hidden;

    img {
      width: 230px;
      height: 200px;
      margin: 0 auto;
      display: block;
    }

    p {
      color: #1a1a1a;
      font-size: 14px;
      text-align: center;
    }
  }

  .css_margin {
    width: 100%;
    border-radius: 12px;
    background-color: #fff;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 99;
    position: relative;
    margin-top: 0px;
  }

  .activity_details_swiper {
    width: 100%;
    overflow: hidden;
    // height: 230px;
    position: relative;

    img {
      width: 100%;
      overflow: hidden;
      // height: 230px;
    }

    span {
      position: absolute;
      display: block;
      width: 42px;
      height: 22px;
      line-height: 22px;
      text-align: center;
      color: #fff;
      font-size: 10px;
      font-weight: 400;
      border-radius: 4px;
      left: 12px;
      top: 12px;
    }

    .page_data_item_img1 {
      background-color: #359eff;
    }

    .page_data_item_img2 {
      background-color: #fff;
      color: #3c3b3f;
    }

    .page_data_item_img3 {
      background-color: #bbbbbb;
    }
  }

  .new_seach {
    // float: right;
    height: 1.2267rem;
    width: 1.2267rem;
    text-align: center;
    line-height: 1.2267rem;

    i {
      font-size: 0.4267rem;
      color: #000;
    }
  }

  .home {
    width: 0.96rem;
    height: 0.96rem;
    position: fixed;
    top: 60%;
    display: flex;
    z-index: 99999;
    right: 0.2667rem;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    background-color: #fff;
    border-radius: 50%;

    i {
      font-size: 0.64rem;
    }
  }

  .goTop {
    width: 0.96rem;
    height: 0.96rem;
    background: #ffffff;
    position: fixed;
    z-index: 99999;
    top: 70%;
    text-align: center;
    font-size: 0.4267rem;
    border-radius: 50%;
    line-height: 0.96rem;
    right: 0.2667rem;
    box-shadow: 0rem 0rem 0.1067rem rgba(0, 0, 0, 0.25);
  }

  .fiex {
    width: 4.5867rem;
    border-radius: 0.1067rem;
    background-color: rgba(0, 0, 0, 0.6);
    position: fixed;
    z-index: 9999;
    bottom: 2.1333rem;
    right: 1.0667rem;
    box-sizing: border-box;
    padding: 0.2667rem 0;

    .fiex_item {
      width: 3.6267rem;
      height: 0.96rem;
      border-radius: 0.4267rem;
      background-color: #fff;
      display: flex;
      flex-direction: row;
      align-items: center;
      box-sizing: border-box;
      padding: 0.08rem;
      margin: 0.2133rem auto;

      img {
        width: 0.8rem;
        height: 0.8rem;
        border-radius: 50%;
        display: block;
        margin-right: 0.16rem;
      }

      span {
        color: #1a1a1a;
        font-size: 0.3733rem;
        font-weight: 400;
      }
    }
  }

  .fiex::after {
    content: '';
    width: 0;
    height: 0;
    border-left: 0.16rem solid transparent;
    border-right: 0.16rem solid transparent;
    border-top: 0.2667rem solid rgba(0, 0, 0, 0.6);
    position: absolute;
    left: 0.4rem;
    bottom: -0.2667rem;
  }

  .nav_list_head {
    width: 100%;
    overflow-y: auto;
    box-sizing: border-box;
    padding: 0 0.4267rem;
    height: 0.96rem;
    white-space: nowrap;
    border-bottom: 0.0267rem solid #f2f2f2;

    .nav_list_head_li {
      //width: 0rem;
      text-align: center;
      margin-right: 0.32rem;
      height: 100%;
      display: inline-block;
      color: #1a1a1a;
      line-height: 0.96rem;
      font-size: 0.4267rem;
      font-weight: 400;
      box-sizing: border-box;
    }

    .active {
      color: #3562ff;
      font-weight: 500;
      border-bottom: 0.0533rem solid #3562ff;
    }
  }

  .nav_list_head::-webkit-scrollbar {
    display: none;
  }

  .nav_list_works {
    width: 100%;
    overflow: hidden;
    box-sizing: border-box;
    padding: 0 0.4267rem;
    height: 1.2267rem;
    display: flex;
    overflow-x: scroll;
    white-space: nowrap;

    .nav_list_works_li {
      // float: left;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      padding: 0 0.16rem;
      margin-right: 0.22rem;
      color: #8f8f8f;
      font-size: 0.3733rem;
      font-weight: 400;
    }

    .active {
      color: #3562ff;
      font-weight: 500;
    }
  }

  .saiqu {
    width: 100%;
    box-sizing: border-box;
    padding: 0 0.4267rem;
    overflow-y: auto;
    white-space: nowrap;
    align-items: center;

    .saiqu_li {
      height: 0.8rem;
      box-sizing: border-box;
      padding: 0 0.2133rem;
      border-radius: 0.32rem;
      color: #8f8f8f;
      font-size: 0.3733rem;
      font-weight: 400;
      line-height: 0.8rem;
      margin-right: 0.32rem;
      display: inline-block;
      background: #f6f6f6;
    }

    .active {
      background: linear-gradient(301.69deg, #6688ff 13.72%, #3360ff 67.35%);
      color: #fff;
    }
  }

  .saiqu::-webkit-scrollbar {
    display: none;
  }

  .saiqu {
    overflow: -moz-scrollbars-none;
  }

  .newAward {
    margin: 0 0 2.1333rem 0;

    .new_award_item {
      .new_award_item_title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-family: YouSheBiaoTiHei;
        color: #1a1a1a;
        height: 33px;

        .new_award_item_title_img {
          width: 24px;
          height: 29px;
          margin-right: 3px;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }
      }

      .new_award_item_context {
        width: 100%;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        // padding: 0.5333rem 0.2rem 0.5333rem 0.2rem;
        padding: 0.2rem 0.2rem 0 0.2rem;
        box-sizing: border-box;
        justify-content: space-between;

        // position: relative;
        .new_award_item_context_item {
          width: 4.7667rem;
          margin-bottom: 0.32rem;
          border-radius: 0.1067rem;
          flex-direction: column;
          border-radius: 0.1067rem;
          display: flex;
          box-sizing: border-box;
          border: 0.0267rem solid #efefef;
          position: relative;
          background-color: #fff;

          .data_list_li_p {
            width: 100%;
            height: 0.8533rem;
            display: flex;
            justify-content: space-between;
            align-items: center;
            box-sizing: border-box;
            padding: 0 0.32rem;

            p {
              margin: 0;
              color: #1a1a1a;
              font-size: 0.2667rem;
              font-weight: 300;
            }

            i {
              color: #8f8f8f;
              font-size: 0.32rem;
              margin-right: 0.08rem;
            }

            span {
              color: #3562ff;
              font-size: 0.2933rem;
              font-weight: 400;
            }
          }

          .abpos {
            position: absolute;
            right: 5px;
            top: 5px;
            width: 32px;
            display: flex;
            z-index: 3;
            align-items: center;
            justify-content: center;
            height: 20px;
            background: rgba(177, 177, 177, 0.3);
            border-radius: 4px;

            i {
              color: #fff;
              font-size: 12px;
            }

            span {
              color: #fff;
              font-size: 10px;
              font-weight: 500;
            }
          }

          img {
            width: 4.7133rem;
            height: 2.4533rem;
            display: block;
            border-radius: 0.1067rem 0.1067rem 0 0;
          }
        }
      }
    }
  }

  .list_tab {
    padding-left: 11px;
    margin-bottom: 9px;
    display: flex;

    .list_tab_item {
      width: 84px;
      height: 26px;
      border-radius: 13px;
      background-color: #f4f4f4;
      display: flex;
      align-items: center;
      color: #1a1a1a;
      justify-content: center;
      font-size: 14px;

      margin-right: 12px;
    }

    .list_active {
      color: #fff;
      font-weight: 600;
      background-color: #6b8cff;
    }
  }

  // 赛区榜单
  .division_table {
    padding: 0 10px 0;

    .organization_title {
      display: flex;
      align-items: center;
      justify-content: center;

      .circle {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-image: linear-gradient(to right, rgb(255, 129, 74), rgba(255, 129, 74, 0.2));
        margin-right: 11px;
      }

      .organization_title_center {
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        font-family: YouSheBiaoTiHei;
        background-color: #ff9252;
        width: 84px;
        height: 24px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      margin-bottom: 9px;
    }

    .organization_box {
      background-color: #ff8d4b;
      // border-top-left-radius: 14px;
      // border-top-right-radius: 14px;
      padding: 0 9px 10px;
      margin: 0 0 2.1333rem 0;
      border-radius: 14px;

      .head_img_box {
        margin: 0 auto;
        width: 315px;
        height: 69px;
        padding-top: 5px;
        transform: translateY(6px);
        display: flex;

        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }

      .organization_content {
        background-color: #fff;
        // border-top-left-radius: 14px;
        // border-top-right-radius: 14px;
        border-radius: 14px;
        padding: 0 5px;
        position: relative;
        padding-bottom: 20px;
        z-index: 10;

        .organization_content_head {
          height: 36px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #8a8f93;

          .organization_name {
            // width: 200px;
            width: 65%;
            text-align: center;
          }

          .number_works {
            width: 40px;
            padding-left: 5px;
          }

          .number_img {
            flex: 1;
            text-align: center;
          }
        }

        .organization_content_item {
          height: 36px;
          border: 1px solid #000;
          border-radius: 14px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #1a1a1a;
          margin-bottom: 12px;

          .list_icon {
            width: 15px;
            height: 17px;
            margin: 0 10px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .icon_txt {
            font-size: 16px;
            font-family: YouSheBiaoTiHei;
            color: #999;
            text-align: center;
          }

          .organization_name {
            width: 65%;
            // width: 200px;
            display: flex;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            align-items: center;

            .organization_logo {
              width: 19px;
              height: 19px;
              margin-right: 5px;

              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }

          .number_works {
            width: 40px;
            padding-left: 10px;
          }

          .number_img {
            display: flex;
            flex: 1;
            justify-content: space-between;
            padding-right: 10px;
            align-items: center;

            .organization_content_item_state {
              .rise {
                display: flex;
                align-items: center;
                color: #f23e3e;

                .rise_icon {
                  width: 7px;
                  height: 4px;
                  margin-right: 2px;
                  background-color: #f23e3e;
                  clip-path: polygon(50% 0, 100% 100%, 0% 100%);
                }
              }

              .decline {
                display: flex;
                align-items: center;
                color: #51dd20;

                .decline_icon {
                  width: 7px;
                  height: 4px;
                  margin-right: 2px;
                  background-color: #51dd20;
                  clip-path: polygon(0 0, 100% 0, 50% 100%);
                }
              }

              .new_ste {
                width: 16px;
                height: 16px;
                font-size: 10px;
                background-color: #f9cdcd;
                color: #f23e3e;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }

  // 机构榜单
  .organization {
    padding: 0 10px 0;

    .organization_title {
      display: flex;
      align-items: center;
      justify-content: center;

      .circle {
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background-image: linear-gradient(to right, rgb(53, 98, 255), rgba(105, 136, 249, 0.2));
        margin-right: 11px;
      }

      .organization_title_center {
        font-size: 14px;
        font-weight: 400;
        color: #fff;
        font-family: YouSheBiaoTiHei;
        background-color: #6b8cff;
        width: 84px;
        height: 24px;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      margin-bottom: 9px;
    }

    .organization_box {
      background-color: #6988f9;
      // border-top-left-radius: 14px;
      // border-top-right-radius: 14px;
      padding: 0 9px 10px;
      margin: 0 0 2.1333rem 0;
      border-radius: 14px;

      .head_img_box {
        margin: 0 auto;
        width: 315px;
        height: 69px;
        padding-top: 5px;
        transform: translateY(13px);

        img {
          object-fit: contain;
          width: 100%;
          height: 100%;
        }
      }

      .organization_content {
        background-color: #fff;
        // border-top-left-radius: 14px;
        // border-top-right-radius: 14px;
        border-radius: 14px;
        padding: 0 5px;
        position: relative;
        padding-bottom: 20px;
        z-index: 10;

        .organization_content_head {
          height: 36px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #8a8f93;

          .organization_name {
            // width: 200px;
            width: 65%;
            text-align: center;
          }

          .number_works {
            width: 40px;
            padding-left: 5px;
          }

          .number_img {
            flex: 1;
            text-align: center;
          }
        }

        .organization_content_item {
          height: 36px;
          border: 1px solid #000;
          border-radius: 14px;
          display: flex;
          align-items: center;
          font-size: 12px;
          color: #1a1a1a;
          margin-bottom: 12px;

          .list_icon {
            width: 15px;
            height: 17px;
            margin: 0 10px;

            img {
              width: 100%;
              height: 100%;
            }
          }

          .icon_txt {
            font-size: 16px;
            font-family: YouSheBiaoTiHei;
            color: #999;
            text-align: center;
          }

          .organization_name {
            width: 65%;
            // width: 200px;
            display: flex;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            align-items: center;

            .organization_logo {
              width: 19px;
              height: 19px;
              margin-right: 5px;

              img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
              }
            }
          }

          .number_works {
            width: 40px;
            padding-left: 10px;
          }

          .number_img {
            display: flex;
            flex: 1;
            justify-content: space-between;
            padding-right: 10px;
            align-items: center;

            .organization_content_item_state {
              .rise {
                display: flex;
                align-items: center;
                color: #f23e3e;

                .rise_icon {
                  width: 7px;
                  height: 4px;
                  margin-right: 2px;
                  background-color: #f23e3e;
                  clip-path: polygon(50% 0, 100% 100%, 0% 100%);
                }
              }

              .decline {
                display: flex;
                align-items: center;
                color: #51dd20;

                .decline_icon {
                  width: 7px;
                  height: 4px;
                  margin-right: 2px;
                  background-color: #51dd20;
                  clip-path: polygon(0 0, 100% 0, 50% 100%);
                }
              }

              .new_ste {
                width: 16px;
                height: 16px;
                font-size: 10px;
                background-color: #f9cdcd;
                color: #f23e3e;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }
      }
    }
  }

  .data_list {
    width: 100%;
    overflow: hidden;

    .van-list {
      width: 100%;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: flex-start;
      box-sizing: border-box;
      // padding: 0.5333rem 0.4267rem;
      // padding: 0.5333rem 0.6267rem;
      padding: 0.5333rem 0.2rem;
      // margin: 0.5333rem 0 2.1333rem 0;
      margin: 0 0 2.1333rem 0;

      /deep/.van-list__loading {
        width: 100%;
        text-align: center;
      }

      /deep/ .van-list__placeholder {
        width: 100%;
        text-align: center;
      }
    }

    .data_list_li {
      float: left;
      // width: 4.2667rem;
      width: 4.7667rem;
      margin-bottom: 0.32rem;
      border-radius: 0.1067rem;
      flex-direction: column;
      border-radius: 0.1067rem;
      display: flex;
      box-sizing: border-box;
      border: 0.0267rem solid #efefef;
      position: relative;
      background-color: #fff;

      .abpos {
        position: absolute;
        right: 5px;
        top: 5px;
        width: 32px;
        display: flex;
        z-index: 3;
        align-items: center;
        justify-content: center;
        height: 20px;
        background: rgba(177, 177, 177, 0.3);
        border-radius: 4px;

        i {
          color: #fff;
          font-size: 12px;
        }

        span {
          color: #fff;
          font-size: 10px;
          font-weight: 500;
        }
      }

      img {
        width: 4.7133rem;
        height: 2.4533rem;
        display: block;
        border-radius: 0.1067rem 0.1067rem 0 0;
      }

      video {
        width: 4.2133rem;
        // height: auto;
        height: 3.76rem;
        display: block;
        border-radius: 0.1067rem 0.1067rem 0 0;
      }

      .data_list_li_p {
        width: 100%;
        height: 0.8533rem;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 0.32rem;

        p {
          margin: 0;
          color: #1a1a1a;
          font-size: 0.2667rem;
          font-weight: 300;
        }

        i {
          color: #8f8f8f;
          font-size: 0.32rem;
          margin-right: 0.08rem;
        }
      }

      span {
        color: #3562ff;
        font-size: 0.2933rem;
        font-weight: 400;
      }
    }
  }
}
</style>
